// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--o9T5Q","text":"_93444fe79c--text--qaKz7"};